<template>
  <div>
    <BaseDialog
      :open="useDialogStore().confirmEmergency.visible"
      width="385px"

      accept-text="Volat SOS"
      dismiss-text="Ne, zpět"
      accept-button-type="danger"
      :is-accepting="isLoading"

      @accept="handleAccept"
      @dismiss="handleDismiss"
    >
      <template #header>
        <h4 class="text-danger-500">
          <icon-emergency />
          <span>Volat SOS</span>
        </h4>
      </template>
      <template #content>
        <div
          class="flex items-center justify-center flex-col font-medium"
        >
          <div class="w-full text-center">
            <span>Opravdu si přejete volat SOS?</span>
          </div>
          <VideoHelp
            class="my-5"
            type="primary"
            size="default"
            youtube="GLhmNc6UCaE"
            title="Volat SOS"
          />
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
export default {
  emits: ['accepted'],

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    async handleAccept() {
      this.isLoading = true;

      const hasAccessToEmergency = await useIpLocation().hasAccessToEmergency();
      if (!hasAccessToEmergency) {
        await sleep(2000);
        useIpLocation().accessToActionDeniedMessage();
        this.isLoading = false;

        return;
      }

      // Check if user already has an emergency request in queue
      if (useAuthStore().isLoggedIn) {
        try {
          const emergencyTypeId = useNuxtApp().$store.state.requests.EMERGENCY_TYPE_ID;
          const requests = await useApi.get('/client/requests', {
            params: {
              limit: 10,
              types: emergencyTypeId,
              states: 1, // Only check requests in queue (waiting state)
            },
          });

          const existingEmergencyRequest = requests.results?.find(
            (request) => request.type_id === emergencyTypeId && request.state_id === 1,
          );

          if (existingEmergencyRequest) {
            this.isLoading = false;
            this.closeDialog();
            ElMessage.error({
              message: 'Máte již SOS požadavek ve frontě. Počkejte prosím na spojení s tlumočníkem.',
              duration: 4000,
              showClose: true,
            });
            this.$router.push(this.$localePath(`/requests/${existingEmergencyRequest.id}/waiting`));
            return;
          }
        } catch (error) {
          console.error('Error checking existing emergency requests:', error);
          // Continue with creation if check fails
        }
      }

      this.$emit('accepted');

      // if (!useAuthStore().isLoggedIn) {
      //   this.$axios.setToken(false);
      // }

      try {
        const data = {
          type_id: 4,
          book_time: null,
          device_id: useDeviceId().getDeviceId(),
        };

        const response = await useApi.post(`/client/${useAuthStore().isLoggedIn ? 'requests' : 'anon-request'}/`, { body: data });

        if (!useAuthStore().isLoggedIn) {
          useAuthStore().setAuth({
            access: response.access,
            refresh: response.refresh,
            user: response.user || {},
          });
          await sleep(200);
          await useAuthStore().fetchUser();

          this.closeDialog();
          await sleep(800);
        }

        this.$router.push(this.$localePath(`/requests/${response.id}/waiting`));
      } catch (error) {
        console.error(error);
        const blocked = blockedMessage(error);

        ElMessage.error({
          message: blocked || 'Omlouváme se, ale došlo k chybě při vytváření požadavku.',
          ...blockedMessageOptions(blocked, 4000),
          showClose: true,
        });
        this.$router.push(this.$localePath('/requests'));
      }

      this.closeDialog();
      this.isLoading = false;
    },
    handleDismiss() {
      this.closeDialog();
    },
    closeDialog() {
      useDialogStore().close('confirmEmergency');
    },
  },
};
</script>
